import React from "react";

const SHORTCUTS = [
  { keys: "Ctrl+K", label: "Search leads" },
  { keys: "N", label: "New enquiry" },
  { keys: "B", label: "Board view" },
  { keys: "L", label: "List view" },
  { keys: "?", label: "Show shortcuts" },
];

const CrmKeyboardHelp = ({ open, onClose }) => {
  if (!open) return null;

  return (
    <div className="crm-kbd-help" role="dialog" aria-label="Keyboard shortcuts">
      <div className="crm-kbd-help__backdrop" onClick={onClose} />
      <div className="crm-kbd-help__panel">
        <h3>Keyboard shortcuts</h3>
        <ul>
          {SHORTCUTS.map((s) => (
            <li key={s.keys}>
              <kbd>{s.keys}</kbd>
              <span>{s.label}</span>
            </li>
          ))}
        </ul>
        <button type="button" onClick={onClose}>
          Close
        </button>
      </div>
    </div>
  );
};

export default CrmKeyboardHelp;
